import get from 'lodash/get';
/**
 * The state selector paths to be persisted.
 */
export const PersistedSelectors = [
    'shortlist.persisted',
    'enquiry.persisted',
    'quote.persisted',
];
/**
 * Persists all selectors in PersistedSelectors in local storage.
 * @param store
 * @returns
 */
export const persistMiddleware = (store) => (next) => (action) => {
    // Ensure state is updated.
    const result = next(action);
    // Retrieve updated state.
    const state = store.getState();
    // Save all selector values to local storage.
    PersistedSelectors.forEach((selector) => {
        localStorage.setItem(getKey(selector), JSON.stringify(get(state, selector)));
    });
    return result;
};
/**
 * Generate local storage key for selector.
 * @param selector
 * @returns
 */
export function getKey(selector) {
    return `lmg::${selector}`;
}
/**
 * Load value for selector from local storage.
 * @param selector
 * @param defaultValue
 * @returns
 */
export function load(selector, defaultValue) {
    const key = getKey(selector);
    try {
        const value = localStorage.getItem(key);
        if (!value) {
            return defaultValue;
        }
        return JSON.parse(value);
    }
    catch (error) {
        return defaultValue;
    }
}
